import { INITIAL_VALUE } from 'components/newAccountSteps/profileSteps/profileStep3/IdentificationMethod/IdentificationMethodContext/constants';
import { createContext } from 'react';

const IdentificationMethodContext = createContext(INITIAL_VALUE);

export default IdentificationMethodContext;
